import { isAfter } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
// eslint-disable-next-line import/no-extraneous-dependencies
import { isValidNumber } from "libphonenumber-js";
import * as yup from "yup";
import { CHECKOUT_PAYMENT_TYPE } from "../../constants";

yup.addMethod(yup.string, "phone", function phone(errorMessage) {
  return this.test(`test-phone`, errorMessage, function testPhone(value) {
    const { path, createError } = this;
    if (!value) return true;

    return (value && isValidNumber(value)) || createError({ path, message: errorMessage });
  });
});

yup.addMethod(yup.string, "actual", function actual(errorMessage, timezone) {
  return this.test(`test-actual`, errorMessage, function testPhone(value) {
    const { path, createError } = this;
    if (!value) return true;
    return (
      isAfter(utcToZonedTime(new Date(value), timezone), utcToZonedTime(new Date(), timezone)) ||
      createError({ path, message: errorMessage })
    );
  });
});

yup.addMethod(yup.object, "card", function card(errorMessage, ignorePaymentTypeCheck = false) {
  return this.test(`test-card-valid`, errorMessage, function testCardValid(value) {
    const { path, createError, parent } = this;

    const paymentType = parent?.pricing?.paymentType;
    const isValid = value?.cardReady === true || value?.defaultCard !== null;

    if (ignorePaymentTypeCheck === true) return isValid || createError({ path, message: errorMessage });
    if (!paymentType || paymentType !== CHECKOUT_PAYMENT_TYPE) return true;
    return isValid || createError({ path, message: errorMessage });
  });
});
